import React, { useState } from "react";
import PricingBreakdown from "./PricingBreakdown";
import confirmRefundFee from "../../../../../controllers/booking/postTicketing/refund/confirmRefundFee";
import { enqueueSnackbar } from "notistack";
import cancelRefundRequest from "../../../../../controllers/booking/postTicketing/refund/cancelRefundRequest";
import Modal1 from "../../../../../components/DIsplay/Modal/Modal1";

function PricingSectionQuoteReady({ data }) {
  const [loading, setLoading] = useState(false);
  const [declining, setDeclining] = useState(false);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [declineModalOpen, setDeclineModalOpen] = useState(false);

  const handleApprove = async () => {
    try {
      setLoading(true);
      const res = await confirmRefundFee(data?._id);

      if (res?.return) {
        enqueueSnackbar("Confirming refund fee successful!", {
          variant: "success",
        });
        setTimeout(() => {
          window.location.reload();
        }, 200);
      } else {
        enqueueSnackbar(
          res?.msg ||
            "Something went wrong confirming fee. Please try again later!",
          { variant: "error" }
        );
      }
    } catch (e) {
      enqueueSnackbar(
        "Something went wrong confirming fee. Please try again later!",
        { variant: "error" }
      );
    } finally {
      setLoading(false);
      setApproveModalOpen(false);
    }
  };

  const handleDecline = async () => {
    try {
      setDeclining(true);
      const res = await cancelRefundRequest(data?._id);

      if (res?.return) {
        enqueueSnackbar("Declining refund fee successful!", {
          variant: "success",
        });
        setTimeout(() => {
          window.location.reload();
        }, 200);
      } else {
        enqueueSnackbar(
          res?.msg ||
            "Something went wrong declining fee. Please try again later!",
          { variant: "error" }
        );
      }
    } catch (e) {
      enqueueSnackbar(
        "Something went wrong declining fee. Please try again later!",
        { variant: "error" }
      );
    } finally {
      setDeclining(false);
      setDeclineModalOpen(false);
    }
  };

  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      {/* Approve confirmation modal */}

      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">Refund</h2>
        <span className="bg-[#FE9F29]/10 text-[#FE9F29] text-sm font-semibold px-3 py-1 rounded-md">
          Awaiting Agent Confirmation
        </span>
      </div>

      {/* Content */}
      <div className="bg-primary1/5 p-4 text-sm text-gray-700">
        <PricingBreakdown data={data} />
        {/* <button
          disabled={loading || declining}
          className="w-full rounded-md h-9 flex items-center justify-center bg-primary1 text-white text-sm font-semibold mt-4 disabled:opacity-60 disabled:cursor-not-allowed"
          onClick={() => setApproveModalOpen(true)}
        >
          {loading ? <div className="buttonLoader" /> : <>Approve</>}
        </button>
        <button
          disabled={loading || declining}
          className="w-full rounded-md h-9 flex items-center justify-center bg-red-600 text-white text-sm font-semibold mt-2 disabled:opacity-60 disabled:cursor-not-allowed"
          onClick={() => setDeclineModalOpen(true)}
        >
          {declining ? <div className="buttonLoader" /> : <>Decline</>}
        </button> */}
      </div>
    </div>
  );
}

export default PricingSectionQuoteReady;
